import Layout from '@/views/layout'

const adminRouter = [{
  path: '/admin',
  component: Layout,
  children: [{
    path: 'index',
    name: 'AdminMeasure',
    meta: {title: '量器管理', module: 'admin', icon: 'measure'},
    component: () => import('@/views/admin/Measure')
  }]
}, {
  path: '/admin/cert',
  component: Layout,
  children: [{
    path: 'cert',
    name: 'AdminCert',
    meta: {title: '证书管理', module: 'admin', icon: 'cert'},
    component: () => import('@/views/admin/Cert')
  }]
}, {
  path: '/admin/chro',
  component: Layout,
  children: [{
    path: 'index',
    name: 'AdminChro',
    meta: {title: '色谱柱管理', module: 'admin', icon: 'state'},
    component: () => import('@/views/admin/Chro')
  }]
}, {
  path: '/admin/team',
  component: Layout,
  children: [{
    path: 'index',
    name: 'AdminTeam',
    meta: {title: '团队管理', module: 'admin', icon: 'team'},
    component: () => import('@/views/admin/Team')
  }]
}]

export default adminRouter
